import fetch from 'unfetch';

const RSVP = async (partyId, user) => {
	const url = `/api/party/rsvp`;
	const res = await fetch(url, {
		method: 'POST',
		headers: {
			'content-type': 'application/json',
			authorization: `${localStorage.getItem('auth')}`,
		},
		body: JSON.stringify({ partyId: partyId, user: user }),
	});

	if (res.ok) {
		console.log(await res.json());
		return { status: 'succ', data: await res.json() };
	} else {
		console.log(await res.json());
		return { status: 'error' };
	}
};
export default RSVP;
